import React from 'react';

import classnames from 'classnames';

import propertyJourneyImage1 from 'assets/images/peoplepropcropped.png';
import proptechJourneyImage2 from 'assets/images/Buildingcropped.png';

import { PROPERTY_JOURNEY_URL, PROPTECH_JOURNEY_URL } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const JourneySwitcher = ({ push }) => (
  <div className={classnames(styles.container, 'fullwidthcontainer')}>
    <div
      onClick={() => push(PROPERTY_JOURNEY_URL)}
      className={classnames(styles.elementleft, 'left')}>
      <div className="remove-xs">
        <Image height="150" width="150" src={propertyJourneyImage1} />
      </div>
      <div className="remove-sm-min">
        <Image width="150" height="150" src={propertyJourneyImage1} />
      </div>
      <div className={styles.title}>I am a Property Professional</div>
    </div>

    <div
      className={styles.elementright}
      onClick={() => push(PROPTECH_JOURNEY_URL)}>
      <div className="remove-xs">
        <Image height="150" width="150" src={proptechJourneyImage2} />
      </div>
      <div className="remove-sm-min">
        <Image width="150" height="150" src={proptechJourneyImage2} />
      </div>
      <div className={styles.title}>I work for a PropTech Company</div>
    </div>
  </div>
);

export default WithPush(JourneySwitcher);
